



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';

// import TitleBar from '@/components/Elements/TitleBar.vue'
import draggable from 'vuedraggable'

@Component({
  computed: {
    ...mapState('ubic', [
      'actor'
    ]),

    ...mapState(STORE_KEY, [
      'vehicles', 'cityId'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setVehicle', 'setEmployee', 'setTime'
    ])
  },
  components: {
    draggable
  }
})
export default class DeliveryZoneMaster extends Vue {

  @Prop() status!: any;
    
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadStatusData`, { status: this.status });
  }

  get targetDeals() {
    return this.status.deals
  }

  set targetDeals(value: any) {
    console.log('value', this.status, value)

    this.$store.dispatch(`${STORE_KEY}/moveDealBetweenStatus`, { status: this.status, newItemList: value });
  }

  get reservesStatelabel() {
    const _reserves = this.status.reserves.filter((res: any) => res.id);

    if (_reserves.length === 0) {
      return 'Тов. запас отсутствует';
    } else {
      return `Позиций тов. запаса: ${_reserves.length}`;
    }
  }

  onCardClick(dealId: string) {
    console.log(dealId)
  }

  // @todo ACTIONS
  // 'save', 'setDeliveryCost', 'confirm', 'print'

}
